import { Logos } from "./logo"
import { Icons } from "./icons"
import { Menu } from "./menu"

export const Sprites = { Logos, Icons, Menu };
export type Sprites = typeof Sprites;

